import axios from "axios"
import { del, get, post, put, postImage, postArray } from "./api_helper"
import * as url from "./url_helper"
import { clearLocalCache } from "./cache_helper"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postLogin = data => post(url.POST_LOGIN, data)
const postLogout = data => post(url.POST_LOGOUT, data)
const postImages = async (data) => {
  const resp = await postImage(url.POST_IMAGES, data)
  .then(response => response)
  return resp;
  //return postImage(url.POST_IMAGES, data)
}

const postImportItems = async (data) => {
  const resp = await postImage(url.POST_IMPORT_PRODUCTS, data)
  .then(response => response)
  return resp;
}


const getCategoryAndSubCategory = data => post(url.GET_CATEGORY_SUBCAT, data)
const getBrands = data => post(url.GET_BRAND_LIST, data)
const getAllProducts = data => post(url.GET_PRODUCTS_LIST, data)
const getHSNs = data => post(url.GET_HSN_LIST, data)
const getTaxes = data => post(url.GET_TAX_LIST, data)
const getUnits = data => post(url.GET_UNIT_LIST, data)
const getSuppliers = data => post(url.GET_SUPPLIER_LIST, data)

const getAllCustomers = data => {
  return post(url.GET_CUSTOMER_LIST, data)
}

const getAllEmployees = data => post(url.GET_EMPLOYEE_LIST, data)
const getAllBanks = data => post(url.GET_BANK_LIST, data)

const getManufacturers = data => post(url.GET_MANUFACTURER_LIST, data)
const getColours = data => post(url.GET_COLOUR_LIST, data)
const getSizes = data => post(url.GET_SIZE_LIST, data)
const getStoreSettings = data => post(url.GET_STORE_SETTINGS, data)
const getCoas = data => post(url.GET_COA_LIST, data)

export const getProductForEdit = id =>
  get(`${url.GET_PRODUCT_DETAIL_FOR_EDIT}/${id}`, { params: { id } })

export const getProductForEditDirect = async (id) =>
get(`${url.GET_PRODUCT_DETAIL_FOR_EDIT}/${id}`, { params: { id } })

export const getPurchaseEntryForEditDirect = async (id) =>
get(`${url.GET_PURCHASE_ENTRY_FOR_EDIT}/${id}`, { params: { id } })

export const getSalesEntryForEditDirect = async (id) =>
get(`${url.GET_SALES_ENTRY_FOR_EDIT}/${id}`, { params: { id } })

export const postExtendSession = async () => {
  return post(url.POST_EXTEND_SESSION,{})
}

export const getProductsDropDown = async (data) => {
  return post(url.GET_PRODUCT_DROPDOWN, data)
}

export const getNextProductCode = async (data) => {
  return post(url.GET_NEXT_PRODUCT_CODE, data)
}

export const getPurchaseEntryList = async (data) => {
  return post(url.ADD_PURCHASE_ENTRY_LIST, data)
}

export const getSalesEntryList = async (data) => {
  return post(url.ADD_SALES_ENTRY_LIST, data)
}

export const getSalesReceiptList = async (data) => {
  return post(url.GET_SALES_RECEIPT_LIST, data)
}
export const getPurchasePaymentList = async (data) => {
  return post(url.GET_PURCHASE_PAYMENT_LIST, data)
}
export const getExpenseList = async (data) => {
  return post(url.GET_EXPENSE_LIST, data)
}
export const getCashInputList = async (data) => {
  return post(url.GET_CASH_INPUT_LIST, data)
}
export const getStateList = async (data) => {
  return post(url.GET_STATE_LIST, data)
}

export const getMasterCoaList = async (data) => {
  return post(url.GET_MASTER_COA_LIST, data)
}

export const getCoaList = async (data) => {
  return post(url.GET_COA_LIST, data)
}

export const postEditSetting = async (data) => {
  clearLocalCache('Settings')
  return post(url.POST_EDIT_SETTING, data)
}

export const getStoreDetails = async (data) => {
  return post(url.GET_STORE_DETAILS, data)
}

export const getSalesChartData = async (data) => {
  return post(url.GET_SALES_CHART_DATA, data)
}

export const getCustomerSalesSummary = async (data) => {
  return post(url.GET_CUSTOMER_SALES_SUMMARY, data)
}

export const getSupplierPurchaseSummary = async (data) => {
  return post(url.GET_SUPPLIER_PURCHASE_SUMMARY, data)
}
export const postSwitchStore = async (data) => {
  return post(url.POST_SWITCH_STORE, data)
}

export const getReport = async (input,type) => {
  let urlToSend = '';
  if(type == 'dayreport'){
    urlToSend = url.GET_DAY_REPORT
  }
  else if(type == 'salesreport'){
    urlToSend = url.GET_SALES_REPORT
  }
  else if(type == 'profitreport'){
    urlToSend = url.GET_PROFIT_REPORT
  }
  
  return post(urlToSend, input)
}

const addNewItem = (data, type) => {
  let urlToSend = '';
  clearLocalCache(type)
  if(type == 'Category'){
    clearLocalCache('SubCategory')
    clearLocalCache('Sub Category')
    urlToSend = url.ADD_CATEGORY
  }
  else if(type == 'SubCategory'){
    clearLocalCache('Category')
    clearLocalCache('Sub Category')
    urlToSend = url.ADD_SUB_CATEGORY
  }
  else if(type == 'HSN'){
    urlToSend = url.ADD_HSN
  }
  else if(type == 'Supplier'){
    urlToSend = url.ADD_SUPPLIER
  }
  else if(type == 'Brand'){
    urlToSend = url.ADD_BRAND
  }
  else if(type == 'Tax'){
    urlToSend = url.ADD_TAX
  }
  else if(type == 'Manufacturer'){
    urlToSend = url.ADD_MANUFACTURER
  }
  else if(type == 'Unit'){
    urlToSend = url.ADD_UNIT
  }
  else if(type == 'Colour'){
    urlToSend = url.ADD_COLOUR
  }
  else if(type == 'Size'){
    urlToSend = url.ADD_SIZE
  }
  else if(type == 'Product'){
    urlToSend = url.ADD_PRODUCT
  }
  
  return post(urlToSend, data)
}

const addNewItemDirect = async (data, type) => {
  clearLocalCache(type)
  let urlToSend = '';
  if(type == 'Category'){
    clearLocalCache('SubCategory')
    clearLocalCache('Sub Category')
    urlToSend = url.ADD_CATEGORY
  }
  else if(type == 'SubCategory'){
    clearLocalCache('Category')
    clearLocalCache('Sub Category')
    urlToSend = url.ADD_SUB_CATEGORY
  }
  else if(type == 'HSN'){
    urlToSend = url.ADD_HSN
  }
  else if(type == 'Supplier'){
    urlToSend = url.ADD_SUPPLIER
  }
  else if(type == 'Brand'){
    urlToSend = url.ADD_BRAND
  }
  else if(type == 'Tax'){
    urlToSend = url.ADD_TAX
  }
  else if(type == 'Manufacturer'){
    urlToSend = url.ADD_MANUFACTURER
  }
  else if(type == 'Unit'){
    urlToSend = url.ADD_UNIT
  }
  else if(type == 'Colour'){
    urlToSend = url.ADD_COLOUR
  }
  else if(type == 'Size'){
    urlToSend = url.ADD_SIZE
  }
  else if(type == 'Product'){
    urlToSend = url.ADD_PRODUCT
  }
  else if(type == 'PurchaseEntry'){
    clearLocalCache('Product')
    urlToSend = url.ADD_PURCHASE_ENTRY
  }
  else if(type == 'Customer'){
    urlToSend = url.ADD_CUSTOMER
  }
  else if(type == 'SalesEntry'){
    urlToSend = url.ADD_SALES_ENTRY
  }
  else if(type == 'COA'){
    urlToSend = url.POST_ADD_COA
  }
  else if(type == 'PaymentEntry'){
    urlToSend = url.POST_ADD_PAYMENTENTRY
  }
  else if(type == 'PurchasePaymentEntry'){
    urlToSend = url.POST_ADD_PURCHASE_PAYMENTENTRY
  }
  else if(type == 'ConfirmImport'){
    clearLocalCache('Product')
    urlToSend = url.POST_CONFIRM_IMPORT
    return postArray(urlToSend, data)
  }
  else if(type == 'Employee'){
    urlToSend = url.POST_ADD_EMP
  }
  else if(type == 'Bank'){
    urlToSend = url.POST_ADD_BANK
  }
  else if(type == 'ExpensePaymentEntry'){
    urlToSend = url.POST_ADD_NEW_EXPENSE
  }
  else if(type == 'CashInputEntry'){
    urlToSend = url.POST_ADD_NEW_CASH_INPUT
  }
  
  return post(urlToSend, data)
}

const editItem = (data, type) => {
  clearLocalCache(type)
  let urlToSend = '';
  if(type == 'Category'){
    clearLocalCache('SubCategory')
    clearLocalCache('Sub Category')
    urlToSend = url.EDIT_CATEGORY
  }
  else if(type == 'SubCategory'){
    clearLocalCache('Category')
    clearLocalCache('Sub Category')
    urlToSend = url.EDIT_SUB_CATEGORY
  }
  else if(type == 'HSN'){
    urlToSend = url.EDIT_HSN
  }
  else if(type == 'Supplier'){
    urlToSend = url.EDIT_SUPPLIER
  }
  else if(type == 'Brand'){
    urlToSend = url.EDIT_BRAND
  }
  else if(type == 'Tax'){
    urlToSend = url.EDIT_TAX
  }
  else if(type == 'Manufacturer'){
    urlToSend = url.EDIT_MANUFACTURER
  }
  else if(type == 'Unit'){
    urlToSend = url.EDIT_UNIT
  }
  else if(type == 'Colour'){
    urlToSend = url.EDIT_COLOUR
  }
  else if(type == 'Size'){
    urlToSend = url.EDIT_SIZE
  }
  else if(type == 'Product'){
    urlToSend = url.EDIT_PRODUCT
  }
  else if(type == 'Customer'){
    urlToSend = url.EDIT_CUSTOMER
  }
  else if(type == 'Employee'){
    urlToSend = url.POST_EDIT_EMP
  }
  return post(urlToSend, data)
}

const editItemDirect = async (data, type) => {
  clearLocalCache(type)
  let urlToSend = '';
  if(type == 'Category'){
    clearLocalCache('SubCategory')
    clearLocalCache('Sub Category')
    urlToSend = url.EDIT_CATEGORY
  }
  else if(type == 'SubCategory'){
    clearLocalCache('Category')
    clearLocalCache('Sub Category')
    urlToSend = url.EDIT_SUB_CATEGORY
  }
  else if(type == 'HSN'){
    urlToSend = url.EDIT_HSN
  }
  else if(type == 'Supplier'){
    urlToSend = url.EDIT_SUPPLIER
  }
  else if(type == 'Brand'){
    urlToSend = url.EDIT_BRAND
  }
  else if(type == 'Tax'){
    urlToSend = url.EDIT_TAX
  }
  else if(type == 'Manufacturer'){
    urlToSend = url.EDIT_MANUFACTURER
  }
  else if(type == 'Unit'){
    urlToSend = url.EDIT_UNIT
  }
  else if(type == 'Colour'){
    urlToSend = url.EDIT_COLOUR
  }
  else if(type == 'Size'){
    urlToSend = url.EDIT_SIZE
  }
  else if(type == 'Product'){
    urlToSend = url.EDIT_PRODUCT
  }
  else if(type == 'Customer'){
    urlToSend = url.EDIT_CUSTOMER
  }
  else if(type == 'PurchaseEntry'){
    clearLocalCache('Product')
    urlToSend = url.EDIT_PURCHASE_ENTRY
  }
  else if(type == 'SalesEntry'){
    urlToSend = url.EDIT_SALES_ENTRY
  }
  else if(type == 'COA'){
    urlToSend = url.POST_EDIT_COA
  }
  else if(type == 'StoreDetails'){
    urlToSend = url.POST_EDIT_STORE_DETAILS
  }
  else if(type == 'PaymentEntry'){
    urlToSend = url.POST_EDIT_PAYMENT_ENTRY
  }
  else if(type == 'PurchasePaymentEntry'){
    urlToSend = url.POST_EDIT_PURCHASE_PAYMENT_ENTRY
  }
  else if(type == 'Employee'){
    urlToSend = url.POST_EDIT_EMP
  }
  else if(type == 'PHoliday'){
    urlToSend = url.POST_EDIT_PHOLIDAY
  }
  else if(type == 'Leave'){
    urlToSend = url.POST_EDIT_EMP_LEAVES
  }
  else if(type == 'Payment'){
    urlToSend = url.POST_EDIT_EMP_PAYEMENT
  }
  else if(type == 'Bank'){
    urlToSend = url.POST_EDIT_BANK
  }
  else if(type == 'ExpensePaymentEntry'){
    urlToSend = url.POST_EDIT_EXPENSE
  }
  
  return post(urlToSend, data)
}

const getLedgerDetails = (type) => {
  return post(url.GET_LEDGER_DETAILS, type)
}
const postAddDefaultUnits = (data) => {
  return post(url.POST_ADD_DEFAULT_UNITS, data)
}
const postAddDefaultTaxes = (data) => {
  return post(url.POST_ADD_DEFAULT_TAXES, data)
}
const postAddDefaultCOA = (data) => {
  return post(url.POST_ADD_DEFAULT_COA, data)
}
const postAddDefaultCOAccounts = (data) => {
  return post(url.POST_ADD_DEFAULT_COACC, data)
}

const postAddDefaultSettings = (data) => {
  clearLocalCache('Settings')
  return post(url.POST_ADD_DEFAULT_SETTINGS, data)
}
const postClearAllServerCache = (data) => {
  return post(url.CLEAR_ALL_CACHE, data)
}

export const getPublicHolidayList = async (data) => {
  return post(url.POST_GET_HOLIDAY_LIST, data)
}
export const addNewHoliday = async (data) => {
  return post(url.POST_ADD_NEW_HOLIDAY, data)
}
export const addEmployeeLedger = async (data) => {
  return post(url.POST_ADD_NEW_EMPLOYEE_LEDGER, data)
}
export const getEmpPaymentAndLeaves = async (data) => {
  return post(url.POST_GET_EMP_PAY_LEAVE_DETAILS, data)
}

export const getExpenseDetails = async (data) => {
  return post(url.GET_EXPENSE_DETAILS, data)
}
const getStockBalance = async (type) => {
  return post(url.GET_STOCK_BALANCE, type)
}

const getOtherUnits = async (type) => {
  return post(url.GET_OTHER_UNITS, type)
}

const deleteItem = (data, type) => {
  if(data.value){
    clearLocalCache(data.value)
  }
  return post(url.DELETE_ITEM, data)
}

const deleteItemDirect = async (data, type) => {
  if(data.value){
    clearLocalCache(data.value)
  }
  return post(url.DELETE_ITEM, data)
}

export const deletePaymentEntry = async (data) => {
  return post(url.DELETE_PAYMENT_ITEM, data)
}

export const deletePurchasePaymentEntry = async (data) => {
  return post(url.DELETE_PURCHASE_PAYMENT_ITEM, data)
}

export const getPreviousSalesId = async (data) => {
  return post(url.POST_GET_PREV_SALES, data)
}

export const getNextSalesId = async (data) => {
  return post(url.POST_GET_NEXT_SALES, data)
}

export const getPreviousPurchaseId = async (data) => {
  return post(url.POST_GET_PREV_PURCHASE, data)
}

export const getNextPurchaseId = async (data) => {
  return post(url.POST_GET_NEXT_PURCHASE, data)
}
// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data)

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data)

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      var message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data)

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data)

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data)

// get Products
export const getProducts = () => get(url.GET_PRODUCTS)

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } })

// get Events
export const getEvents = () => get(url.GET_EVENTS)

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event)

// update Event
export const updateEvent = event => put(url.UPDATE_EVENT, event)

// delete Event
export const deleteEvent = event =>
  del(url.DELETE_EVENT, { headers: { event } })

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES)

// get chats
export const getChats = () => get(url.GET_CHATS)

// get groups
export const getGroups = () => get(url.GET_GROUPS)

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS)

// get messages
export const getMessages = (roomId = "") =>
  get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } })

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message)

// get orders
export const getOrders = () => get(url.GET_ORDERS)

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order)

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order)

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } })

// get cart data
export const getCartData = () => get(url.GET_CART_DATA)

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS)

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer)

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer)

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } })

// get shops
export const getShops = () => get(url.GET_SHOPS)

// get wallet
export const getWallet = () => get(url.GET_WALLET)

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS)

// get invoices
export const getInvoices = () => get(url.GET_INVOICES)

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } })

// get project
export const getProjects = () => get(url.GET_PROJECTS)

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } })

// get tasks
export const getTasks = () => get(url.GET_TASKS)

// get contacts
export const getUsers = () => get(url.GET_USERS)

// add user
export const addNewUser = user => post(url.ADD_NEW_USER, user)

// update user
export const updateUser = user => put(url.UPDATE_USER, user)

// delete user
export const deleteUser = user => del(url.DELETE_USER, { headers: { user } })

/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project)

// update user
export const updateProject = project => put(url.UPDATE_PROJECT, project)

// delete user
export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } })

export const getUserProfile = () => get(url.GET_USER_PROFILE)

// get inboxmail
export const getInboxMails = () => get(url.GET_INBOX_MAILS)

// add inboxmail
export const addNewInboxMail = inboxmail =>
  post(url.ADD_NEW_INBOX_MAIL, inboxmail)

// delete inboxmail
export const deleteInboxMail = inboxmail =>
  del(url.DELETE_INBOX_MAIL, { headers: { inboxmail } })

// get starredmail
export const getStarredMails = () => get(url.GET_STARRED_MAILS)

// get importantmail
export const getImportantMails = () => get(url.GET_IMPORTANT_MAILS)

// get sent mail
export const getSentMails = () => get(url.GET_SENT_MAILS)

// get trash mail
export const getTrashMails = () => get(url.GET_TRASH_MAILS)

// get starredmail
export const getDraftMails = () => get(url.GET_DRAFT_MAILS)

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA)
export const getYearlyData = () => get(url.GET_YEARLY_DATA)
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA)

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } })

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } })

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS)

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  })
}
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  })
}

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  })
}

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  })
}

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,

  postLogin,
  postImages,
  postImportItems,
  getCategoryAndSubCategory,
  addNewItem,
  getBrands,
  getHSNs,
  getTaxes,
  getUnits,
  getAllProducts,
  getSuppliers,
  getColours,
  getSizes,
  getManufacturers,
  editItem,
  deleteItem,
  editItemDirect,
  deleteItemDirect,
  addNewItemDirect,
  getStoreSettings,
  getLedgerDetails,
  getAllCustomers,
  getAllEmployees,
  getAllBanks,
  getStockBalance,
  getOtherUnits,
  postLogout,
  postAddDefaultUnits,
  postAddDefaultTaxes,
  postAddDefaultCOA,
  postAddDefaultCOAccounts,
  postAddDefaultSettings,
  getCoas,
  postClearAllServerCache
}
